import { Switch } from 'react-router-dom';
import ProtectedRoute from '../../utils/ProtectedRoute';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import ScheduledTransactions from './ScheduledTransactions/ScheduledTransactionsContainer';
import ScheduledTransactionDetails from './ScheduledTransactions/Details/ScheduledTransactionDetailsContainer';
import { JSX } from 'react';

const Routes = (): JSX.Element => {
  const featureFlags = useModuleFeatureFlag('transactions');

  return (
    <Switch>
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/scheduled-transactions"
        component={ScheduledTransactions}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/scheduled-transactions/details/:TransactionID"
        component={ScheduledTransactionDetails}
      />
    </Switch>
  );
};

export default Routes;
